import { render, staticRenderFns } from "./ToolbarTabs.vue?vue&type=template&id=09ac9539&"
import script from "./ToolbarTabs.vue?vue&type=script&lang=js&"
export * from "./ToolbarTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports